import { DS_getData, type DS_TData } from '../DS/DS.Data'
import type { User_TAppPriv } from './User.IUser'

export function User_get(d?: DS_TData) {
    d = d || DS_getData()
    return d.user
}

export function User_isLoggedIn(d?: DS_TData) {
    return User_get(d) != null
}

export function User_audioThemeGet(d?: DS_TData) {
    if (!User_isLoggedIn(d)) return null

    return (User_get(d).prefs || {}).audio_theme || null
}

export function User_vibrationOn(d?: DS_TData) {
    if (!User_isLoggedIn(d)) return false

    return (User_get(d).prefs || {}).vibrate === 'on'
}

export function User_hasPriv(priv: User_TAppPriv, d?: DS_TData) {
    if (!User_isLoggedIn(d)) return false

    const { privs } = User_get(d)
    if (privs == null || privs.app == null) return false

    return privs.app.includes(priv)
}

export function User_languageGet(d?: DS_TData) {
    if (!User_isLoggedIn(d)) return 'en-GB'

    return User_get(d).language
}

export function User_localeGet(d?: DS_TData) {
    if (!User_isLoggedIn(d)) return 'en-GB'

    return User_get(d).locale
}
